import { Link } from "react-router-dom";
import { useGetQuizesByVideoIdQuery } from "../../../features/quiz/quizApi";
import { useGetQuizMarkByVideoIdAndStudentIdQuery } from "../../../features/quizMark/quizMarkApi";
import { useSelector } from "react-redux";

export default function QuizButton({ videoId }) {
	const { id: studentId } = useSelector((state) => state.auth.user) || {};
	const {
		data: quizzes,
		isSuccess: isGetQuizzesSuccess,
		isError: isGetQuizzesError,
	} = useGetQuizesByVideoIdQuery(videoId, {
		refetchOnMountOrArgChange: true
	}) || {};
	const {
		data: quizMarks,
		isSuccess: isQuizMarkGetSuccess,
		isError: isQuizMarkGetError,
	} = useGetQuizMarkByVideoIdAndStudentIdQuery({ videoId, studentId }, {
		refetchOnMountOrArgChange: true
	}) || {};

	if ((isGetQuizzesSuccess && quizzes?.length === 0) || isGetQuizzesError) {
		return null;
	}

	// Decide what to render
	if (
		isGetQuizzesSuccess &&
		quizzes?.length > 0 &&
		isQuizMarkGetSuccess &&
		!(isQuizMarkGetSuccess && quizMarks?.length > 0)
	) {
		return (
			<Link
				to={`/quizzes/${videoId}`}
				className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary"
			>
				কুইজে অংশগ্রহণ করুন
			</Link>
		);
	} else if (isQuizMarkGetSuccess && quizMarks?.length > 0) {
		return (
			<div className="">
				<button className="px-3 font-bold py-1 rounded-full text-sm btn-success">
					Quiz Submitted
				</button>
				<span className="font-bold ml-8">
					Obtained mark: {quizMarks[0].mark}/{quizMarks[0].totalMark}
				</span>
			</div>
		);
	}
}
